module.exports = __webpack_public_path__ + "img/greaterthan.2715d2f0.svg";